var map = {
	"./design-astro.jpg": 13,
	"./design-hddicon.jpg": 14,
	"./design-ssbanner.jpg": 15,
	"./game-kameleon.jpg": 16,
	"./game-ripple.png": 17,
	"./game-snake.png": 18,
	"./mg-da.jpg": 19,
	"./mg-equally.jpg": 20,
	"./mg-kasuga.jpg": 21,
	"./site-digitalarts.jpg": 22,
	"./site-eyepetizer.jpg": 23,
	"./site-fenz.png": 24,
	"./site-jinkan.jpg": 25,
	"./site-torriacg.jpg": 26,
	"./site-wzjunding.jpg": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;



/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works ^\.\/.*$
 ** module id = 40
 ** module chunks = 1
 **/